import React, { useState, useEffect } from 'react';
import { Bot } from 'lucide-react';
import { useHelp } from './TourContext';

const HelpButton = ({ pageName }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const { isHelpModeActive, toggleHelpMode, triggerRobotAnimation } = useHelp();

  const handleClick = () => {
    toggleHelpMode(pageName);
  };

  const getTooltipText = () => {
    return isHelpModeActive ? 'Close Help' : 'Show Help';
  };
  
  // Trigger animation when triggerRobotAnimation changes
  useEffect(() => {
    if (triggerRobotAnimation > 0 && isHelpModeActive) {
      setIsAnimating(true);
      const timer = setTimeout(() => {
        setIsAnimating(false);
      }, 600); // Animation duration
      return () => clearTimeout(timer);
    }
  }, [triggerRobotAnimation, isHelpModeActive]);

  return null;
};

export default HelpButton;
